export default "__VITE_ASSET__CMPgzCEU__"